"use client";

import { useResolvedCity } from "@/hooks/useResolvedCity";

function slugify(s: string): string {
  return s
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

/**
 * Returns the treatment href: /city/slug (or /city/parent/child) if city is valid (cityName or useResolvedCity),
 * otherwise /slug (or /parent/child).
 */
export function useTreatmentHref(slug: string, parentSlug?: string, cityName?: string | null): string {
  const resolved = useResolvedCity();
  const city = cityName ?? resolved;
  const basePath = parentSlug ? `/${parentSlug}/${slug}` : `/${slug}`;
  if (city) return `/${slugify(city)}${basePath}`;
  return basePath;
}

export function linkTreatmentWithCity(slug: string, parentSlug?: string, cityName?:string|null): string {
  const basePath = parentSlug ? `/${parentSlug}/${slug}` : `/${slug}`;
  if (cityName) return `/${slugify(cityName)}${basePath}`;
  return basePath;
}
